import React from "react";
import { Helmet } from "react-helmet-async";
import Layout from "../../../Login/components/layout";
import VerifyEmailPage from "../../components/verifyEmail";
import GuestRoute from "../../components/GuestRoute";

const VerifyEmailContainer = () => (
  <GuestRoute>
    <main>
      <Helmet title="Email Verification" />
      <Layout>
        <VerifyEmailPage />
      </Layout>
    </main>
  </GuestRoute>
);

export default VerifyEmailContainer;